import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import ConfirmPopup from '../components/common/ConfirmPopup';

export const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
    const [state, setState] = useState({
        visible: false,
        title: '',
        message: '',
        confirmText: 'Yes',
        cancelText: 'No'
    });

    const resolver = useRef(null);

    const confirm = useCallback((options) => {
        const { title, message, confirmText, cancelText } = typeof options === 'string' 
            ? { message: options } 
            : options;

        setState({
            visible: true,
            title: title || 'Confirm Action',
            message: message || 'Are you sure you want to proceed?',
            confirmText: confirmText || 'Yes',
            cancelText: cancelText || 'No'
        });

        return new Promise((resolve) => {
            resolver.current = resolve;
        });
    }, []);

    const handleConfirm = useCallback(() => {
        setState(prev => ({ ...prev, visible: false }));
        if (resolver.current) resolver.current(true);
    }, []);

    const handleCancel = useCallback(() => {
        setState(prev => ({ ...prev, visible: false }));
        if (resolver.current) resolver.current(false);
    }, []);

    return (
        <ConfirmContext.Provider value={confirm}>
            {children}
            <ConfirmPopup
                visible={state.visible}
                title={state.title}
                message={state.message}
                confirmText={state.confirmText}
                cancelText={state.cancelText}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </ConfirmContext.Provider>
    );
};

export const useConfirm = () => {
    const context = useContext(ConfirmContext);
    if (!context) {
        throw new Error('useConfirm must be used within a ConfirmProvider');
    }
    return context;
};
